import {
  EXTRA_LARGE_VIEWPORT,
  LARGE_VIEWPORT,
  MEDIUM_VIEWPORT,
  SMALL_VIEWPORT,
} from "../../../../../state/modules/layout";

export const EXTRA_LARGE_VIEWPORT_MIN_SIZE = 1920;

export const GRID_EXPANSION_COLUMN_COUNT = {
  [SMALL_VIEWPORT]: 2,
  [MEDIUM_VIEWPORT]: 3,
  [LARGE_VIEWPORT]: 4,
  [EXTRA_LARGE_VIEWPORT]: 6,
};

const getGridViewportCategory = ({
  clientWidth,
  hasCuratedElevatedProductTiles,
  viewportCategory,
}) => {
  if (
    clientWidth > EXTRA_LARGE_VIEWPORT_MIN_SIZE &&
    !hasCuratedElevatedProductTiles
  ) {
    return EXTRA_LARGE_VIEWPORT;
  }

  if (viewportCategory === EXTRA_LARGE_VIEWPORT) {
    return LARGE_VIEWPORT;
  }

  return viewportCategory || LARGE_VIEWPORT;
};

const getGridExpansionLayout = ({
  clientWidth,
  hasCuratedElevatedProductTiles,
  viewportCategory,
}) => {
  const gridViewportCategory = getGridViewportCategory({
    clientWidth,
    hasCuratedElevatedProductTiles,
    viewportCategory,
  });

  return {
    viewportCategory: gridViewportCategory,
    columnCount: GRID_EXPANSION_COLUMN_COUNT[gridViewportCategory],
  };
};

export default getGridExpansionLayout;
